import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import SiteLayout from './components/SiteLayout';
import HomePage from './pages/HomePage';
import AnalysisPage from './pages/AnalysisPage';
import ProjectsPage from './pages/ProjectsPage';
import SolutionsPage from './pages/SolutionsPage';
import ConsultingPage from './pages/ConsultingPage';
import JcConsultorPremiumPage from './pages/JcConsultorPremiumPage';
import JcBasePage from './pages/JcBasePage';
import ContactPage from './pages/ContactPage';
import IncidenciesPage from './pages/IncidenciesPage';
import ProductsPageNew from './pages/ProductsPageNew';
import ProductPage from './pages/ProductPage';
import ProblemsPage from './pages/ProblemsPage';
import ProblemPage from './pages/ProblemPage';
import ServiceDetailPage from './pages/services/ServiceDetailPage';
import ProjectDetailPage from './pages/projects/ProjectDetailPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import SeoHubPage from './pages/SeoHubPage';
import SeoArticlePage from './pages/SeoArticlePage';
import LocalSeoHubPage from './pages/LocalSeoHubPage';
import LocalSeoPage from './pages/LocalSeoPage';
import CalendarReservationPage from './pages/CalendarReservationPage';
import ConstructProPage from './pages/ConstructPro';
import './site.css';

function ScrollAnimator() {
  const location = useLocation();

  useEffect(() => {
    AOS.init({
      duration: 700,
      once: true,
      offset: 40,
      easing: 'ease-out-cubic',
    });
  }, []);

  useEffect(() => {
    if (location.hash) {
      window.setTimeout(() => {
        document.querySelector(location.hash)?.scrollIntoView({ block: 'start' });
        AOS.refreshHard();
      }, 0);
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    AOS.refreshHard();
  }, [location.pathname, location.hash]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollAnimator />
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/analisis-gratuito" element={<AnalysisPage />} />
          <Route path="/analisis" element={<Navigate to="/analisis-gratuito" replace />} />
          <Route path="/productos" element={<ProductsPageNew />} />
          <Route path="/jc-base" element={<JcBasePage />} />
          <Route path="/productos/jc-base" element={<Navigate to="/jc-base" replace />} />
          <Route path="/constructpro" element={<ConstructProPage />} />
          <Route path="/productos/constructpro" element={<Navigate to="/constructpro" replace />} />
          <Route path="/productos/:slug" element={<ProductPage />} />
          <Route path="/problemas" element={<ProblemsPage />} />
          <Route path="/problemas/:slug" element={<ProblemPage />} />
          <Route path="/proyectos" element={<ProjectsPage />} />
          <Route path="/projectes" element={<ProjectsPage />} />
          <Route path="/soluciones" element={<SolutionsPage />} />
          <Route path="/solucions" element={<SolutionsPage />} />
          <Route path="/soluciones/:slug" element={<ServiceDetailPage />} />
          <Route path="/solucions/:slug" element={<ServiceDetailPage />} />
          <Route path="/consultoria" element={<ConsultingPage />} />
          <Route path="/jc-consultor-premium" element={<JcConsultorPremiumPage />} />
          <Route path="/consultoria-informatica" element={<LocalSeoHubPage />} />
          <Route path="/consultoria-informatica/:slug" element={<LocalSeoPage />} />
          <Route path="/reservar-hora" element={<CalendarReservationPage />} />
          <Route path="/contacto" element={<ContactPage />} />
          <Route path="/contacte" element={<ContactPage />} />
          <Route path="/incidencias" element={<IncidenciesPage />} />
          <Route path="/incidencies" element={<IncidenciesPage />} />
          <Route path="/politica-privacidad" element={<PrivacyPolicyPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/guias" element={<SeoHubPage />} />
          <Route path="/guias/:slug" element={<SeoArticlePage />} />
          <Route path="/proyectos/:slug" element={<ProjectDetailPage />} />
          <Route path="/projectes/:slug" element={<ProjectDetailPage />} />
        </Route>

        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
